// Exports
export default {
	"Unsupported_container": "Unsupported_container_CNAjs",
	"containerWithoutHeaderAndFooter": "containerWithoutHeaderAndFooter_NgXGk",
	"Unsupported_title": "Unsupported_title_HrPuI",
	"Unsupported_subtitle": "Unsupported_subtitle_tP+Lx"
};
